/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlInviterResponse
 */
export interface ControlInviterResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlInviterResponse
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlInviterResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlInviterResponse
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlInviterResponse
     */
    last_name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlInviterResponse
     */
    active: boolean;
}

/**
 * Check if a given object implements the ControlInviterResponse interface.
 */
export function instanceOfControlInviterResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function ControlInviterResponseFromJSON(json: any): ControlInviterResponse {
    return ControlInviterResponseFromJSONTyped(json, false);
}

export function ControlInviterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlInviterResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'email': json['email'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'active': json['active'],
    };
}

export function ControlInviterResponseToJSON(value?: ControlInviterResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'email': value.email,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'active': value.active,
    };
}

